import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import { PrintTemplateActivity } from '../../../../../models/activities';
import { FormGroup } from '@angular/forms';
import { WorkflowContextService } from '../../../../../services';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-print-template-activity-view',
    templateUrl: './print-template-activity-view.component.html',
    styleUrls: ['./print-template-activity-view.component.css'],
    standalone: false
})
export class PrintTemplateActivityViewComponent extends ActivityView
  implements OnInit {
  activity: PrintTemplateActivity;
  documentPath: SafeUrl;
  documentName: string;
  templateForPermitForm: boolean = false

  constructor( public layoutService: LayoutService, private sanitizer: DomSanitizer,public context : WorkflowContextService) {
    super();
      layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
  }

  ngOnInit() {
    this.documentName = this.activity.model.evaluatedDocName;
    this.documentPath = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.activity.model.documentPath
    );
  }
}
